import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NetworkHelper } from '../helpers';
import { Observable } from 'rxjs';
import { SHARED_ENV } from '../tokens';

@Injectable()
export class SettingsService {
  private readonly env = inject(SHARED_ENV);
  readonly hostUrl: string;

  constructor(private router: Router, private networkHelper: NetworkHelper) {
    this.hostUrl = this.env.host;
  }

  getSettings(key: string | null = null): Observable<any> {
    const data: any = {};
    if (key) {
      data['key'] = key;
    }

    return this.networkHelper.post(`${this.hostUrl}/settings`, data);
  }

  setSetting(key: string, value: any): Observable<any> {
    return this.networkHelper.post(`${this.hostUrl}/settings/edit`, {
      key: key,
      value: value,
    });
  }
}
